import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import MyContext from "../ContextApi/MyContext";

export default function UserLogin() {
  const { login, user } = useContext(MyContext);

  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState(""); // optional - not heavily used right now

  const navigate = useNavigate();

  // Redirect if already logged in (using context user - more reliable)
  useEffect(() => {
    if (user) {
      navigate("/user-profile/ticket-generate", { replace: true });
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Clear previous error messages
    const emailErrorEl = document.getElementById("email-error");
    const passwordErrorEl = document.getElementById("password-error");
    if (emailErrorEl) emailErrorEl.innerText = "";
    if (passwordErrorEl) passwordErrorEl.innerText = "";

    try {
      const res = await fetch("https://technic-mentors-backend.vercel.app/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(credentials),
      });

      const json = await res.json();

      if (res.ok && json && json.email) {
        console.log("[Login] Saving user:", json);

        // Use context → updates both sessionStorage and global state
        login(json);

        // Small delay for better UX (optional)
        setTimeout(() => {
          navigate("/user-profile/ticket-generate", { replace: true });
        }, 150);
      } else {
        const errMsg = json.error || "Invalid email or password";
        if (emailErrorEl) {
          emailErrorEl.innerText = errMsg;
        }
        // You can also setError(errMsg); if you want to show it differently
      }
    } catch (err) {
      console.error("[Login] Network/fetch error:", err);
      if (emailErrorEl) {
        emailErrorEl.innerText = "Cannot connect. Please check your internet.";
      }
    }
  };

  const onChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  return (
    <div style={{ backgroundColor: "#f1f6fe" }} className="background-img5">
      <div className="color-overlay5">
        <div className="allHeaderBg">
          <div className="allHeader-overlay d-flex align-items-center justify-content-center">
            <div>
              <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
                Sign In
              </h1>
            </div>
          </div>
        </div>

        <div className="container py-5">
          <div className="row align-items-center g-5">
            {/* Left Side - Marketing / Trust Content */}
            <div className="col-lg-6">
              <div className="pe-lg-4">
                <h2 className="display-5 fw-bold mb-4" style={{ color: "#684df4" }}>
                  Welcome Back!
                </h2>
                <p className="lead mb-4" style={{ color: "#424242", lineHeight: "1.8" }}>
                  Access your dashboard, generate tickets, and continue building with us.
                  Your next big idea is just a login away.
                </p>

                <div className="mb-4">
                  <div className="d-flex align-items-start mb-3">
                    <div
                      className="me-3"
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "12px",
                        backgroundColor: "#e3f2fd",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i className="fas fa-ticket-alt" style={{ color: "#684df4", fontSize: "20px" }}></i>
                    </div>
                    <div>
                      <h5 className="mb-1" style={{ color: "#684df4" }}>
                        Quick Ticket Generation
                      </h5>
                      <p className="mb-0" style={{ color: "#616161" }}>
                        Submit and track support requests in seconds
                      </p>
                    </div>
                  </div>

                  <div className="d-flex align-items-start mb-3">
                    <div
                      className="me-3"
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "12px",
                        backgroundColor: "#e8f5e9",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i className="fas fa-chart-line" style={{ color: "#684df4", fontSize: "20px" }}></i>
                    </div>
                    <div>
                      <h5 className="mb-1" style={{ color: "#684df4" }}>
                        Track Progress
                      </h5>
                      <p className="mb-0" style={{ color: "#616161" }}>
                        Real-time updates on all your requests
                      </p>
                    </div>
                  </div>

                  <div className="d-flex align-items-start">
                    <div
                      className="me-3"
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "12px",
                        backgroundColor: "#fff3e0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i className="fas fa-headset" style={{ color: "#684df4", fontSize: "20px" }}></i>
                    </div>
                    <div>
                      <h5 className="mb-1" style={{ color: "#684df4" }}>
                        Priority Support
                      </h5>
                      <p className="mb-0" style={{ color: "#616161" }}>
                        Fast responses from our expert team
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className="mt-4 p-4"
                  style={{
                    backgroundColor: "white",
                    borderRadius: "16px",
                    borderLeft: "4px solid #684df4",
                  }}
                >
                  <p className="mb-2" style={{ color: "#616161", fontSize: "14px" }}>
                    <i className="fas fa-quote-left me-2" style={{ color: "#684df4" }}></i>
                    "Fast login, intuitive dashboard — exactly what our team needed."
                  </p>
                  <p className="mb-0 fw-semibold" style={{ color: "#684df4", fontSize: "14px" }}>
                    — Ahmed R., Project Manager
                  </p>
                </div>
              </div>
            </div>

            {/* Right Side - Login Form */}
            <div className="col-lg-6">
              <div
                className="p-4 p-lg-5"
                style={{
                  backgroundColor: "white",
                  borderRadius: "20px",
                  boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                }}
              >
                <h3 className="mb-4 fw-bold" style={{ color: "#684df4" }}>
                  Sign In to Your Account
                </h3>

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label fw-semibold" style={{ color: "#424242" }}>
                      Email Address
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      style={{
                        padding: "12px 16px",
                        borderRadius: "10px",
                        border: "2px solid #e0e0e0",
                      }}
                      name="email"
                      value={credentials.email}
                      onChange={onChange}
                      id="email"
                      placeholder="john@example.com"
                      required
                    />
                    <div className="text-danger mt-1" id="email-error" style={{ fontSize: "14px" }}></div>
                  </div>

                  <div className="mb-4">
                    <label htmlFor="password" className="form-label fw-semibold" style={{ color: "#424242" }}>
                      Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      style={{
                        padding: "12px 16px",
                        borderRadius: "10px",
                        border: "2px solid #e0e0e0",
                      }}
                      name="password"
                      value={credentials.password}
                      onChange={onChange}
                      id="password"
                      placeholder="••••••••"
                      required
                    />
                    <div className="text-danger mt-1" id="password-error" style={{ fontSize: "14px" }}></div>
                  </div>

                  <button
                    type="submit"
                    className="btn w-100 py-3 fw-semibold"
                    style={{
                      backgroundColor: "#684df4",
                      color: "white",
                      borderRadius: "10px",
                      border: "none",
                      fontSize: "16px",
                      transition: "all 0.3s",
                    }}
                  >
                    Sign In
                    <i className="fas fa-arrow-right ms-2"></i>
                  </button>
                </form>

                <p className="text-center mt-4 mb-0" style={{ color: "#616161" }}>
                  Don't have an account?{" "}
                  <Link
                    to="/signup"
                    style={{
                      color: "#684df4",
                      textDecoration: "none",
                      fontWeight: "600",
                    }}
                  >
                    Create Account
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}